import { c as _c } from "react/compiler-runtime";
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph';
import { Label2 } from '@/frontend/design-system/typography/Label';
import { cn } from '@/frontend/utils';
type StepBarItemProps = {
  stepId: number;
  isStepCompleted: boolean;
  title: React.ReactNode;
  onClick?: () => void;
};
export function StepBarItem(t0) {
  const $ = _c(17);
  const {
    stepId,
    isStepCompleted,
    title,
    onClick
  } = t0;
  const t1 = isStepCompleted ? "border-contentColorPrimary" : "border-slate-300 dark:border-borderPrimary";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("cursor-pointer appearance-none border-l-4 bg-transparent p-0 pl-2 text-left sm:w-full sm:border-t-4 sm:border-l-0 sm:pt-2 sm:pl-0", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isStepCompleted ? "text-contentColorPrimary" : "text-contentTertiary";
  let t4;
  if ($[2] !== t3) {
    t4 = cn(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== stepId || $[5] !== t4) {
    t5 = <Label2 className={t4}>Krok {stepId}</Label2>;
    $[4] = stepId;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isStepCompleted ? "" : "dark:text-contentTertiary";
  let t7;
  if ($[7] !== t6) {
    t7 = cn("text-contentPrimary", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7 || $[10] !== title) {
    t8 = <P3 className={t7}>{title}</P3>;
    $[9] = t7;
    $[10] = title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== onClick || $[13] !== t2 || $[14] !== t5 || $[15] !== t8) {
    t9 = <button type="button" className={t2} onClick={onClick}>{t5}{t8}</button>;
    $[12] = onClick;
    $[13] = t2;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}